module.exports = __webpack_public_path__ + "static/img/brand_good.89fe3070.png";